import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import Dropdown from "../../components/Dropdown";

@inject('GameStore')
@observer
export default class GameStep3 extends Component {

    componentWillMount() {
        if (this.props.GameStore.levels.length === 0) {
            this.props.GameStore.loadQuestions();
        }
    }

    onChangePlayerLevel(index, player, e) {
        this.props.GameStore.setLevelToPlayerAt(player, e.name, index);
    }

    render() {

        const {
            levels,
            players,
            teamsComposition,
            numberPlayers
        } = this.props.GameStore;

        const participants = teamsComposition.find(t => numberPlayers === t.teams).participants;
        const Participants = ({player}) => (
            <div className="participants">
                {new Array(participants).fill("").map(
                    (p, index) => <Dropdown
                        key={index}
                        items={levels}
                        nullOption="N/A"
                        onChange={this.onChangePlayerLevel.bind(this, index, player)}/>
                )}
            </div>);

        const teamsEl = players.map(
            (player, index) => (
                <div className="team-name" key={index}>
                    <label className={player.team.color}>{player.name}</label>
                    <Participants player={player}/>
                </div>
            )
        );

        return (
            <div className="step-3">
                <h1>Participants’ Levels</h1>
                <div className="teams">
                    {teamsEl}
                </div>
            </div>
        )
    }

};


// WEBPACK FOOTER //
// ./src/containers/Game/GameStep3.js